var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmacao-cancelamento"},[_c('CardCancelar',{staticClass:"item",attrs:{"userInfo":_vm.user,"planInfo":_vm.planInfo}}),_c('CardConfirmacaoCancelamento',{staticClass:"item"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }